// extracted by mini-css-extract-plugin
module.exports = {"form":"EditAutomatedCommunication_form__3nfa9","footer":"EditAutomatedCommunication_footer__1faZj"};